module.exports = "h1 {\n  text-align: center;\n}\n\nh1 .headline-holder {\n  display: inline-block;\n  padding-bottom: 15px;\n  text-align: left;\n}\n\ninput.form-input:focus {\n  outline: none;\n  border: 0 !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/achelos-iot/login-page/login-page.component.css
// module id = ./src/app/achelos-iot/login-page/login-page.component.css
// module chunks = main